import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n';

// Layout components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/layout/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import GalleryPage from './pages/GalleryPage';
import ProtocolsPage from './pages/ProtocolsPage';
import ContactsPage from './pages/ContactsPage';
import PrivacyPolice from './pages/PrivacyPolice';
import License from './pages/License';


function App() {
  useEffect(() => {
    const retryImage = (img) => {
      const count = parseInt(img.dataset.retryCount || '0', 10);
      if (count >= 2) return;
      img.dataset.retryCount = String(count + 1);
      const src = img.src;
      img.removeAttribute('src');
      requestAnimationFrame(() => { img.src = src; });
    };

    const onImgError = (e) => {
      if (e.target && e.target.tagName === 'IMG' && e.target.src) {
        setTimeout(() => retryImage(e.target), 1000);
      }
    };
    document.addEventListener('error', onImgError, true);

    const preloadVisibleImages = () => {
      document.querySelectorAll('img[src]').forEach(img => {
        if (!img.complete && img.naturalWidth === 0) {
          const p = new Image();
          p.src = img.src;
        }
      });
    };

    const observer = new MutationObserver((mutations) => {
      let found = false;
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'IMG' || (node.querySelectorAll && node.querySelectorAll('img').length)) {
            found = true; break;
          }
        }
        if (found) break;
      }
      if (found) requestAnimationFrame(preloadVisibleImages);
    });

    const root = document.getElementById('root');
    if (root) observer.observe(root, { childList: true, subtree: true });

    const t1 = setTimeout(preloadVisibleImages, 500);
    const t2 = setTimeout(preloadVisibleImages, 2000);
    const t3 = setTimeout(preloadVisibleImages, 5000);

    return () => {
      document.removeEventListener('error', onImgError, true);
      observer.disconnect();
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-background text-foreground">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/protocols" element={<ProtocolsPage />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/privacypolice" element={<PrivacyPolice />} />
            <Route path="/license" element={<License />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
